import { IAppState } from '@/app-state';
import { poItemChangeRequestsReducer } from '@/app/areas/unacknowledged-po/details/components/change-requests/po-item-change-requests-reducer';
import { poItemHoldRequestsReducer } from '@/app/areas/unacknowledged-po/details/components/hold-requests/po-item-hold-requests-reducer';
import { changeRequestReducer } from '@/app/areas/unacknowledged-po/details/components/create-change-request/change-request-reducer';
import * as DetailsReducers from '@/app/areas/unacknowledged-po/details/reducers';
import { poItemsRevisedReducer } from '@/app/areas/unacknowledged-po/details/detail-reducers/revised-items-reducer';
import { poListReducer } from '@/app/areas/unacknowledged-po/list/reducers';
import { conversationReducer, notesReducer } from '@/app/common/conversation/reducers';
import { changeRequestReasonTypesReducer } from '@/app/common/reference-data/reference-data-reducers';
import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  Middleware,
  Store,
} from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { rootSaga } from './root-saga';
import { poChangeRequestReducer } from '@/app/areas/unacknowledged-po/details/components/create-po-change-request/reducers';
import { userReducer } from '@/app/common/user/reducer';
import featureFlagsReducer from '../featureFlags/featureFlagsReducer';
import { userAccessPoliciesReducer } from '../userAccessPolicy/reducer';
import { userProfileReducer } from '../userProfile/reducer';

export const storeFactory = (config: AppConfig, initialState?: IAppState): Store<IAppState> => {
  let devTools = () => { };

  const loggerMiddleware = createLogger() as Middleware;
  const sagaMiddleware = createSagaMiddleware();
  const middlewares: Middleware[] = [sagaMiddleware];

  if (config.debugMode) {
    devTools = ((<any>window).__REDUX_DEVTOOLS_EXTENSION__)
      ? ((<any>window).__REDUX_DEVTOOLS_EXTENSION__)
      : () => { };

    middlewares.push(loggerMiddleware);
  }

  const createStoreWithMiddleware = compose(
    applyMiddleware(...middlewares)
  )(createStore);

  const store = createStoreWithMiddleware(
    combineReducers<IAppState>({
      poChangeRequestState: poChangeRequestReducer,
      changeRequestReasonTypesState: changeRequestReasonTypesReducer,
      changeRequestState: changeRequestReducer,
      conversationState: conversationReducer,
      notesState: notesReducer,
      poApprovePoState: DetailsReducers.poApprovePoReducer,
      poDetailsState: DetailsReducers.poDetailsReducer,
      poDetailsBucketTotalsState: DetailsReducers.poDetailsBucketTotalsReducer,
      poItemChangeRequestsState: poItemChangeRequestsReducer,
      poItemHoldRequestsState: poItemHoldRequestsReducer,
      poItemsState: DetailsReducers.poItemsReducer,
      poItemsRevisedState: poItemsRevisedReducer,
      confirmedItemsState: DetailsReducers.confirmedPoItemsReducer,
      poListState: poListReducer,
      userState: userReducer,
      featureFlagsState: featureFlagsReducer,
      userAccessPolicyState: userAccessPoliciesReducer,
      userProfileState: userProfileReducer,
    }),
    initialState,
    // Uncomment this to debug with the Redux Developer Tools. Do not use in production
    // (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
  );

  sagaMiddleware.run(rootSaga);

  return store as Store<IAppState>;
};
